import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import css from './styles.module.css';

type MenuHeadingProps = {
  children: React.ReactNode;
};

export function MenuHeading({ children }: MenuHeadingProps) {
  return (
    <DropdownMenu.Label className={css.heading}>{children}</DropdownMenu.Label>
  );
}
